var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("b-row", { staticClass: "topInfoRow" }, [
        _c(
          "div",
          { staticClass: "card noBoxShadow col6-left" },
          [
            _c("div", [
              !_vm.areThereFilters
                ? _c("h4", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getLength(_vm.organizations)) +
                        "\n        "
                    )
                  ])
                : _c("h4", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.totalRows) +
                        " of " +
                        _vm._s(_vm.getLength(_vm.organizations)) +
                        "\n        "
                    )
                  ]),
              _vm._v(" "),
              _c("p", [_vm._v("Organizations")])
            ]),
            _vm._v(" "),
            _c(
              "b-button",
              {
                attrs: { variant: "primary" },
                on: { click: _vm.addOrganization }
              },
              [_vm._v("Add New Organization")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card noBoxShadow col6-right" },
          [
            _c("div", [
              _c("h4", [_vm._v("Search")]),
              _vm._v(" "),
              _c("p", [_vm._v("By Organization Name, Street, City or State")])
            ]),
            _vm._v(" "),
            _c(
              "b-input-group",
              { staticClass: "searchClearInput" },
              [
                _c("b-form-input", {
                  attrs: { placeholder: "Type to Search" },
                  on: { input: _vm.handleFilterChange },
                  model: {
                    value: _vm.filter.nameText,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "nameText", $$v)
                    },
                    expression: "filter.nameText"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-input-group-addon",
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: { disabled: !_vm.filter.nameText },
                        on: { click: _vm.clearFilter }
                      },
                      [_vm._v("Clear")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-btn",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle.collapse1",
                  modifiers: { collapse1: true }
                }
              ],
              staticClass: "filterBtn bgDarkBlue",
              attrs: { variant: "primary" }
            },
            [
              _vm._v("Filters"),
              _c("img", {
                staticStyle: { "margin-left": "14px" },
                attrs: {
                  src: require("../../../../static/img/filterIcon.png"),
                  width: "17px",
                  height: "11px"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "filterCollapse marginB-62",
              attrs: { id: "collapse1" }
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "div",
                    { staticClass: "div1" },
                    [
                      _c("span", [_vm._v("Filters")]),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.resetFilters.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("Reset to defaults")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "div2" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "County / Parish" } },
                          [
                            _c("b-form-select", {
                              staticClass: "greySelect",
                              attrs: { options: _vm.countyOrParishOptions },
                              model: {
                                value: _vm.selectedCountyOrParish,
                                callback: function($$v) {
                                  _vm.selectedCountyOrParish = $$v
                                },
                                expression: "selectedCountyOrParish"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "State" } },
                          [
                            _c("b-form-select", {
                              staticClass: "greySelect",
                              attrs: {
                                options: [
                                  { value: null, text: "Choose..." }
                                ].concat(_vm.states)
                              },
                              model: {
                                value: _vm.selectedState,
                                callback: function($$v) {
                                  _vm.selectedState = $$v
                                },
                                expression: "selectedState"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "submit", variant: "primary" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.updateSearchResults.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n          Save\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "h2",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.finishedLoading,
                  expression: "!finishedLoading"
                }
              ],
              staticClass: "u-padding-bottom-20"
            },
            [_vm._v("Loading, please wait ...")]
          ),
          _vm._v(" "),
          _c("pulse-loader", {
            attrs: {
              loading: !_vm.finishedLoading,
              color: _vm.spinnerColor,
              size: _vm.spinnerSize
            }
          }),
          _vm._v(" "),
          _c("b-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.finishedLoading,
                expression: "finishedLoading"
              }
            ],
            attrs: {
              filter: _vm.filter,
              "filter-function": _vm.searchFilter,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
              hover: true,
              striped: true,
              bordered: false,
              small: true,
              fixed: true,
              responsive: "sm",
              items: _vm.organizations,
              fields: _vm.getTableFields(),
              "per-page": 20,
              "current-page": _vm.currentPage
            },
            on: {
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function(item) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "b-link",
                        {
                          on: {
                            click: function($event) {
                              return _vm.goOrganization(item.item.id)
                            }
                          }
                        },
                        [_c("span", {}, [_vm._v(_vm._s(item.value))])]
                      )
                    ],
                    1
                  )
                }
              },
              {
                key: "b_confirmed",
                fn: function(item) {
                  return _c("div", {}, [
                    _c("span", { attrs: { "v-if": item.value !== "" } }, [
                      _vm._v(_vm._s(item.value))
                    ])
                  ])
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.getLength(_vm.organizations),
              "prev-text": "Prev",
              "next-text": "Next",
              "current-page": _vm.currentPage
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-367b4d4e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-367b4d4e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/OrganizationList.vue
// module id = 1850
// module chunks = 0